
'use strict';

(function () {
	var App = angular.module('pphhApp');
	App.controller("dashboardController", ["$scope", "$window","$mdDialog","$http", "$interval", "DashboardService",
		"CommonCatalogService", "pphhEnv", DashboardController]);
							
	function DashboardController($scope, $window, $mdDialog, $http, $interval, dashboardService, 
		commonCatalogService, pphhEnv) {
						
		$scope.activityMonitorDhs = [];
		$scope.activityMonitorDh = "";
		
		$scope.activityMonitorCcaas = [];
		$scope.activityMonitorCcaa = "";
		
		$scope.isLoading = false; 

		$scope.activityTypes = [];
		$scope.activityType = "";
		
		$scope.activityTypeStates = [];
		$scope.activityTypeState = "";
		
		$scope.filterResults = [];

		$scope.admResponsableDesc = '';
		$scope.admResponsable= '';

		$scope.cicloList= [];
		$scope.ciclo = "";
		
		$scope.waterModule = "";
		$scope.waterModules = [];
		
		/*
		 * Mantis 0003381. Es necesario inicializar pageSize, porque si no, no funcionan 
		 * los popups aunque en consola no salgan errores
		 */
		$scope.pageSize = 10;

		$scope.init = init;
		$scope.clearFilter = clearFilter;
		$scope.doFilter = doFilter;
		$scope.doFilterSearch = doFilterSearch;
		$scope.doInfoUser = doInfoUser;
		$scope.doFilterMonitor = doFilterMonitor;
		$scope.doFilterMonitorSearch = doFilterMonitorSearch;
		$scope.navigate = navigate;
		$scope.downloadLoadedFile = downloadLoadedFile;
		$scope.downloadLoadingActivityReport = downloadLoadingActivityReport;
		$scope.downloadLoadingActivityFullReport = downloadLoadingActivityFullReport;
		$scope.downloadLoadingActivityDetailedReport = downloadLoadingActivityDetailedReport;
		$scope.anyOptionAvaliable = anyOptionAvaliable;
		$scope.renderExploreActionIf = renderExploreActionIf;
		$scope.renderDownloadLoadedFileIf = renderDownloadLoadedFileIf;
		$scope.renderDownloadLoadingActivityReportIf = renderDownloadLoadingActivityReportIf;
		$scope.renderDownloadLoadingActivityFullReportIf = renderDownloadLoadingActivityFullReportIf;
		$scope.renderDownloadActivityDetailedReportIf = renderDownloadActivityDetailedReportIf;
		$scope.alertIsNull = alertIsNull;


		function init() {

			commonCatalogService.getWaterModules()
			.then(function (response) {
				$scope.waterModules.push({"key":"", "value":""})
				$scope.waterModules = $scope.waterModules.concat( response.data );

			});

			$scope.$watch("waterModule", function (moduleName) {
				
				if (moduleName === "") {
					$scope.activityType = "";
					$scope.activityTypeState = "";
					$scope.ciclo = "";
					$scope.admResponsable='';
					$scope.activityMonitorDh = "";
					$scope.activityMonitorCcaa = "";
					
				} else {
					dashboardService.getActivityMonitorDh($scope.waterModule)
					.then(
							function (response) { 
								$scope.activityMonitorDhs = response.data;
								if($scope.activityMonitorDhs.length === 1) {
									$scope.activityMonitorDh = $scope.activityMonitorDhs[0].id;
								}
							}
					);
					
					dashboardService.getActivityMonitorCcaa($scope.waterModule)
					.then(
							function (response) { 
								$scope.activityMonitorCcaas = response.data;
								if($scope.activityMonitorCcaas.length === 1) {
									$scope.activityMonitorCcaa = $scope.activityMonitorCcaas[0].id;
								}
							}
					);
					
					commonCatalogService.getVersions($scope.waterModule)
					.then(
							function(response) {
								$scope.cicloList = response.data;
								$scope.ciclo = "";
								if($scope.cicloList.length === 1) {
									$scope.ciclo = $scope.cicloList[0].id;
								} 
							}
					);
					
					$scope.openAdmResponsableDialog = function () {

						$scope.admResponsable='';
						$scope.admResponsableDesc='';

						$scope.roleName = '';

						$http({
							method: "GET",
							url: "/dashboard/user/role"
						})
						.then(
								function (response) {
									var queryResults = response.data; 
									if(queryResults.length === 1) {
										$scope.roleName = queryResults[0];

										$mdDialog.show({
											clickOutsideToClose: true,
											controller: "OpenAdmResponsableDialogController",
											parent: angular.element(document.body),
											templateUrl: "/cc/adm-dialog/template",
											resolve: {
												roleName: function () {
													return $scope.roleName;
												}
											}
										})
										.then(
												function (selected) {
													$scope.admResponsable =  selected.key;
													$scope.admResponsableDesc = selected.value;
												}
										);
									}
								},
								function () {
									$mdDialog.show(
											$mdDialog.alert({
												title: UIMessages.dialog.confirm.title,
												textContent: "Error lookup",
												ok: UIMessages.dialog.confirm.cerrar
											}));
								}
						);
					};
					
					dashboardService.getActivityTypes($scope.waterModule)
					.then(
							function (response) {
								$scope.activityTypes = response.data;
								if($scope.activityTypes.length === 1) {
									$scope.activityType = $scope.activityTypes[0].id;
								}
							}
					);
				}
			});

			$scope.$watch("activityType", function (type) {
				$scope.activityTypeState = "";
				if(type != null) {
					dashboardService.getActivityTypeStates($scope.waterModule, type)
					.then(
							function (response) {
								$scope.activityTypeStates = response.data;
							}
					);
				}
			});
		}

		function clearFilter() {
			$scope.activityType = ""; 
			$scope.activityTypes = [];
			$scope.activityTypeState = "";
			$scope.activityMonitorDh = "";
			$scope.activityMonitorCcaa = "";
			$scope.admResponsable = null;
			$scope.admResponsableDesc = '';
			$scope.cicloList= [];
			$scope.ciclo = "";
			$scope.waterModule = "";
				
			var form = $scope.filterForm;
			form.$setPristine();
		
			if($scope.stCtrl) {
				var tableState = $scope.stCtrl.tableState();			
				tableState.pagination.start = 0;
				$scope.filterResults = [];
				$scope.stCtrl.pipe();
			}
		}
			
		function doFilter(tableState, ctrl) {

			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return; 
			}
		
			doFilterSearch(tableState); 
		}
			
		function doFilterSearch(tableState) {
			
			if (!tableState) {
				tableState = $scope.stCtrl.tableState();
				tableState.pagination.start = 0;
			}

			$scope.isLoading = true;
				
				var baseFilter = {
						activityType: $scope.activityType,
						activityTypeState: $scope.activityTypeState,
						module: $scope.waterModule,
						ciclo: $scope.ciclo
				};
				
			var fullFilter =
				SmartTableUtils.copyAndSetGenericPaginationParams(
							tableState, baseFilter);
 
			dashboardService.getPendingTasks(fullFilter)
			.then(
					function(response) { 
						var queryResults = response.data;
						if(response.data.results) {
							$scope.filterResults = queryResults.results;
							$scope.pageSize = queryResults.pageSize;
							SmartTableUtils.updateTableState(tableState, queryResults);

							setupActivityMonitoring($scope.filterResults);
						}
						SmartTableUtils.updateTableState(tableState, response.data);
						
						$scope.isLoading = false;

					},
					function () {
						$mdDialog.show(
								$mdDialog.alert({
									title: UIMessages.dialog.confirm.title,
									textContent: "Error get",
									ok: UIMessages.dialog.confirm.cerrar
								}));

						$scope.isLoading = false;
					}
			);
		}

		function doInfoUser(row) {

			$mdDialog.show({
				clickOutsideToClose: true,
				controller: UserInfoDialogController,
				templateUrl: "/activityMonitor/infoUser" ,
				locals : {
					tlf:row.tlf,
					email:row.email
				}
			});
		}
				
		function doFilterMonitor(tableState, ctrl) {

			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if(!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return; 
			}
	
			doFilterMonitorSearch(tableState); 
	 	}
		
		function doFilterMonitorSearch(tableState) {
		
			if (!tableState) {
				tableState = $scope.stCtrl.tableState();
				tableState.pagination.start = 0;
			}

			$scope.isLoading = true;
		
				var filter = {
						activityType: $scope.activityType,
						activityTypeState: $scope.activityTypeState,
						activityMonitorDh: $scope.activityMonitorDh,
						activityMonitorCcaa: $scope.activityMonitorCcaa,
						activityAdmin: $scope.admResponsable,
						module: $scope.waterModule,
						ciclo: $scope.ciclo	
				};
			var fullFilter =
				SmartTableUtils.copyAndSetGenericPaginationParams(
							tableState, filter);

				dashboardService.getPendingMonitorTasks(fullFilter)
					.then(
							function(response) {
								var queryResults = response.data; 
								if(response.data.results) { 
									$scope.filterResults = queryResults.results;
									$scope.pageSize = queryResults.pageSize;
									SmartTableUtils.updateTableState(tableState, queryResults);

									setupActivityMonitoring($scope.filterResults);
								}
								SmartTableUtils.updateTableState(tableState, response.data);

								$scope.isLoading = false;

							},
							function () {
								$mdDialog.show(
										$mdDialog.alert({
											title: UIMessages.dialog.confirm.title,
											textContent: "Error get",
											ok: UIMessages.dialog.confirm.cerrar
										}));

								$scope.isLoading = false;
							}
					);
		}

		function navigate(row) {
			if(row.entityName) {
				$window.location.href = pphhEnv.global.contextPath + "/pphhNav-init"
				+ "?cicloId=" + row.cicloId
				+ "&entityName=" + row.entityName
				+ "&instanceId=" + (row.instanceId || row.oldInstanceId)
				+ "&actId=" + row.id
				+ "&module=" + row.module.key
				;
			} else {
				$window.location.href = pphhEnv.global.contextPath + "/pphhNav-init"
				+ "?cicloId=" + row.cicloId
				+ "&actId=" + row.id
				+ "&module=" + row.module.key
				;
			}
		}

		function downloadLoadedFile(row) {
			$window.location.href = pphhEnv.global.contextPath + "/dashboard/loadingTask/" + row.id + "/file";
		}
	
		function downloadLoadingActivityReport(row) {
			$window.location.href = pphhEnv.global.contextPath + "/dashboard/loadingTask/" + row.id + "/report";
		}
	
		function downloadLoadingActivityFullReport(row) {
			$window.location.href = pphhEnv.global.contextPath + "/dashboard/loadingTask/" + row.id + "/fullReport";
		}

		function downloadLoadingActivityDetailedReport(row) {
			var url = pphhEnv.global.contextPath + "/dashboard/loadingTask/" + row.id + "/detailedReport";
			$window.open(url);
		}
	
		function renderExploreActionIf(row) {
			return row.availableActions.length > 0;
		}

		function alertIsNull(row) {
			return row.alert === null;
		}
	
		function anyOptionAvaliable (row){
			return renderDownloadLoadedFileIf(row) || renderDownloadLoadingActivityReportIf(row) || 
					renderDownloadLoadingActivityFullReportIf (row) || renderDownloadActivityDetailedReportIf(row); 
		}
		function renderDownloadLoadedFileIf(row) {			
			return row.stateId !== -2 && row.stateId !== -3 && row.downloadFile;
		}
	
		function renderDownloadLoadingActivityReportIf(row) {
			return row.stateId !== 1 && row.stateId !== 3 && row.fullReportFile;
		}
	
		function renderDownloadLoadingActivityFullReportIf(row) {
			return row.stateId !== 1 && row.stateId !== 3 && row.fullReportFile;
		}

		function renderDownloadActivityDetailedReportIf(row) {
			return row.stateId !== -2 && row.stateId !== -3;
		}
	
		var activityMonitoringPromises = {};
	
		/**
		 * Establece la lógica de refresco para las actividades de carga en
		 * los estados donde es necesario notificar un progreso:
		 *  - 1: No iniciada
		 *  - 3: Procesando
		 *  - 5: Consolidando 
		 */
		function setupActivityMonitoring(activities) {
			if(activities) {
				for(var i = 0; i < activities.length; i++) {
					var activity = activities[i];
					if(activityNeedsPolling(activity)) {
						clearActivityProgressMonitor(activity);
	
						activityMonitoringPromises["Id" + activity.id] =
							$interval(monitorActivityProgress, 10000, 0, true, activity);
					}
				}
			}
		}
		
		function activityNeedsPolling(activity) {
			return activity.typeId === 2 &&
			(activity.stateId === 1
					|| activity.stateId === 3
					|| activity.stateId === 5);
		}
	
		function monitorActivityProgress(activity) {
			if (activityNeedsPolling(activity)) {
				dashboardService.getActivityProgress(activity.id)
				.then(function (response) {
					activity.state = response.data.value;
					activity.stateId = response.data.key;
				});
			} else {
				clearActivityProgressMonitor(activity);
	
				dashboardService.getActivity(activity.id)
				.then(
						function (response) {
							var newData = response.data;
							angular.forEach(newData, function (value, p) {
								activity[p] = value;
							});
						});
			}
		}
	
		function clearActivityProgressMonitor(activity) {
			var promise = activityMonitoringPromises["Id" + activity.id];
			if (promise) {
				$interval.cancel(promise);
				activityMonitoringPromises["Id" + activity.id] = null;
			}
		}
	}

	function UserInfoDialogController($scope, tlf, email) {
		$scope.tlf = tlf;
		$scope.email = email;
	}
	
})();

